import React from 'react'
import BulletChart from 'Components/Stats/BulletChart'
import injectStyles from 'react-jss'
import Note from 'Components/Stats/BulletChart/Note'
import { GridItem } from 'Components/Page/StatsPageWrapper'

const styles = {
  bulletChartWithNote: {
    paddingTop: 30,
  },
}

const UnstyledBulletChartGroup = props => {
  const { title, note, classes, ...otherProps } = props

  return (
    <div>
      <h1>{title}</h1>

      <GridItem>
        <BulletChart
          {...otherProps}
          className={note ? classes.bulletChartWithNote : null}
        >
          {note ? <Note>{note}</Note> : null}
        </BulletChart>
      </GridItem>
    </div>
  )
}

/**
 * @typedef BulletChartGroupProps
 * @property {string} note Optionally display a note
 * @property {number} targetValue
 * @property {number} actualValue
 * @property {boolean} showAsPercent Shows the indicators as percentage
 * values instead of numerical values
 * @property {string} title The chart group title
 *
 * @param {BulletChartGroupProps} props
 */
const BulletChartGroup = injectStyles(styles)(UnstyledBulletChartGroup)

export default BulletChartGroup



// WEBPACK FOOTER //
// ./src/Components/Stats/BulletChartsForMetric/BulletChartGroup.js